import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { keys } from "./keys";

async function fetchTopic(id: string) {
  const { data, error } = await apiClient
    .from('topics')
    .select()
    .eq('id', id)
    .limit(1)
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function useGetTopicById(id: string | undefined) {
  return useQuery({
    queryKey: keys.topic(id ?? ''),
    queryFn: () => fetchTopic(id!),
    enabled: !!id,
    staleTime: _3_DAYS,
  });
}
